import React from 'react';
import ReactDOM from 'react-dom';

import App from './components/App/index';

import './index.scss'

ReactDOM.render(
	<App size={350}/>,
	document.getElementById("root")
);
